import { Star } from "@components/icons"
import breakpoints from "@constants/breakpoints"
import React from "react"
import styled from "styled-components"

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const Icon = styled.div<{ $filled: boolean }>`
  width: 14.17px;
  height: 14.17px;
  margin-right: 4px;
  opacity: ${(props) => (props.$filled ? 1 : 0.3)};
  line-height: initial;

  @media ${breakpoints.laptop} {
    width: 18.96px;
    height: 17.63px;
    margin-right: 8px;
  }

  svg {
    vertical-align: initial;
  }
`

interface IProps {
  className?: string
  stars: number
}

const Stars = (props: IProps) => (
  <Container className={props.className}>
    {Array(5)
      .fill(null)
      .map((value, index) => (
        <Icon $filled={index < props.stars} key={index}>
          <Star />
        </Icon>
      ))}
  </Container>
)

export default Stars
